function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".person_svg__cls-1{fill:#333}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "person_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "person_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "person_svg__cls-1",
  cx: 14.5,
  cy: 7.33,
  r: 7.33
}), /*#__PURE__*/React.createElement("path", {
  className: "person_svg__cls-1",
  d: "M0 29v-3.67C0 21.28 4.33 18 9.67 18h9.66c5.34 0 9.67 3.28 9.67 7.33V29"
})));

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 29"
  }, props), _ref, _ref2);
}

export default SvgPerson;